import React from 'react';
import classNames from 'classnames';
import { Checkbox as KitCheckbox, CheckboxChangeEvent } from '@myua/kit';

// Публичная сигнатура НЕ менялась (MYUA-16744, этап 2.6): раньше это был свой
// SVG-чекбокс на классах старого semantic-подобного слоя, теперь под капотом
// antd. Второй аргумент `shift` обязателен — на нём висит выделение диапазона
// строк в таблицах (fileManager, trash, shared links).
export interface CheckboxProps {
  isChecked: boolean;
  disabled?: boolean;
  onChange: (newValue: boolean, shift: boolean) => void;
  label?: string;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  isChecked,
  onChange,
  label,
  className = '',
  disabled = false,
}) => {
  return (
    <KitCheckbox
      className={classNames('gen-checkbox', className)}
      disabled={disabled}
      checked={isChecked}
      onChange={(e: CheckboxChangeEvent) => {
        // React для чекбокса маппит onChange на нативный `click`, поэтому
        // shiftKey читается именно оттуда. Проверка типа осталась той же,
        // что была до миграции.
        const nativeEvent = e.nativeEvent;
        let shift = false;
        if (nativeEvent.type === 'click') {
          shift = (nativeEvent as MouseEvent).shiftKey;
        }
        onChange(e.target.checked, shift);
      }}
    >
      {label || null}
    </KitCheckbox>
  );
};

export default Checkbox;
